import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { translate } from 'react-i18next';
import { Grid, Header, Loader } from 'semantic-ui-react';

import setProfileSchema from '../../schemas/setProfile';
import setProfileShape from '../../shapes/setProfileShape';
import SnukForm from '../reusable/SnukForm';
import { get } from '../../utils/communications';
import { apiEndpoint } from '../../utils/env';

class SetProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userExists: undefined,
    };
    this.setProfile = this.setProfile.bind(this);
  }

  componentDidMount() {
    get(`${apiEndpoint}/users/user`)
      .then(() => {
        this.setState({ userExists: true });
      })
      .catch((e) => {
        if (e.errors[0].code === 'user_not_found') {
          this.setState({ userExists: false });
        } else {
          this.setState({ userExists: true });
        }
      });
  }

  setProfile(id, info) {
    this.props.setUserProfile(info)
      .then(() => window.location.replace('/overview'));
  }

  render() {
    const { userExists } = this.state;
    const { t, user } = this.props;
    const { validation, isSetProfilePending } = user;
    const { isError, message } = validation;

    if (typeof userExists === 'undefined') {
      return <Loader size="small" active inline="centered" className="fetcher-loader" />;
    } if (userExists) {
      return <Redirect to="/overview" />;
    }
    return (
      <Grid>
        <Grid.Row style={{ paddingTop: '10vh' }}>
          <Grid.Column computer="6" mobile="1" tablet="2" />
          <Grid.Column computer="4" mobile="14" tablet="12">
            <Header as="h1" textAlign="center">{t('common.profile-cfg')}</Header>
            <SnukForm
              externalMessage={{ isError, messages: message.length > 1 ? [message] : [] }}
              onSubmitAction={this.setProfile}
              isPending={isSetProfilePending}
              schema={setProfileSchema}
              shape={setProfileShape}
              btnText={t('common.nickname')}
            />
          </Grid.Column>
          <Grid.Column computer="6" mobile="1" tablet="2" />
        </Grid.Row>
      </Grid>
    );
  }
}

SetProfile.propTypes = {
  t: PropTypes.func.isRequired,
  setUserProfile: PropTypes.func.isRequired,
  user: PropTypes.shape({}).isRequired,
};

export default translate()(SetProfile);



// WEBPACK FOOTER //
// ./src/components/SetProfile/SetProfile.js